import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { CommonService } from 'app/singleton-services/common.service';
import { AuthenticationService } from './authentication.service';

@Injectable()
export class StartupService {
    private _isBusy = true;

    private _status = false;

    constructor(
        private authenticationService: AuthenticationService,
        private translateService: TranslateService,
        private commonService: CommonService, // required for initialization
        private router: Router
    ) {}

    get isBusy() {
        return this._isBusy;
    }

    get status() {
        return this._status;
    }

    async init(): Promise<void> {
        try {
            // configure oidc
            // await this.authenticationService.configureOidc();

            // init authentication (will propagate user subject)
            await this.authenticationService.chekcAuthenticationData();

            // load current user
            await this.authenticationService.loadCurrentUser();

            this._status = true;
        } catch (e) {
            console.log(e);
        } finally {
            this._isBusy = false;
        }

        // app should not start if metadata not loaded
        if (!this._status) {
            this.router.navigate(['/error/500']);
            return;
        }

        // route navigate, disabled by config, therefore must be triggered here.
        // navigateByUrl parses the browser url like any other navigation: path segments are decoded
        // once and serialized back as they were. navigate([window.location.pathname]) treated the
        // still-encoded path as plain text and encoded it again, so a percent-encoded route param
        // (the token in /resetPassword/:username/:code) gained one more layer on every page load
        // and arrived at the server as garbage (RM 46306).
        this.router.navigateByUrl(window.location.pathname + window.location.search + window.location.hash, {
            replaceUrl: true
        });
    }
}
